<template>
  <ul class="nav nav-mobile-menu">
    <drop-down>
      <template slot="title">
        <i class="nc-icon nc-bullet-list-67"></i>
      </template>
      <a @click.prevent="lock" class="dropdown-item" href="#">
        <i class="nc-icon nc-lock-circle-open"></i> Bloquear
      </a>
      <a href="#" @click.prevent="signout" class="dropdown-item text-danger">
        <i class="nc-icon nc-button-power"></i> Cerrar Sesión
      </a>
    </drop-down>
  </ul>
</template>
<script>
  import DropDown from 'src/components/Dropdown.vue'
  import { mapActions } from 'vuex'

  export default {
    components: {
      DropDown
    },
    methods: {
      // mapeamos las acciones de nuestro store para poder llamarlas desde este script
      ...mapActions({
        logout: 'auth/logout',
        cleanUserlogout: 'auth/cleanUserlogout'
      }),

      // llamamos a nuestra accion para limpiar el token, luego limpiamos el usuario
      signout () {
        this.logout().then(() => {  
          this.$router.push('/login')
          this.cleanUserlogout()
        })
      },
      lock(){
        let data = {
            user: this.$store.state.auth.user.username,
            name: this.$store.state.auth.user.first_name+' '+this.$store.state.auth.user.last_name,
            avatar: this.$store.state.auth.user.avatar,
            active: 0
        }
        localStorage.setItem( 'user', JSON.stringify(data) )        
        this.$router.push('/lock')
        localStorage.removeItem('token')
      },      
    }
  }
</script>
<style>
</style>
